export const EXTERNAL_LINK_URL = {
    FB_CUSTOMER_SERVICE: 'https://m.me/homexin2019',
};
